// src/components/common/LoadingSpinner.js
import React from 'react';
import './LoadingSpinner.css';

export default function LoadingSpinner({
  size = 'medium',
  centered = true,
  className = '',
  label = 'Loading',
}) {
  return (
    <div
      className={`bf-loading-spinner-wrap ${centered ? 'is-centered' : ''} ${className}`}
      role="status"
      aria-label={label}
    >
      <div className={`bf-loading-spinner bf-loading-spinner-${size}`} />
    </div>
  );
}
